import React, { useContext } from 'react'
import { FieldArrayRenderProps } from 'react-final-form-arrays'
import { villeEnum } from '../enums/formulaireChangementAppartementEnum'
import { Grid, IconButton } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import classNames from 'classnames'
import { getKeyFromEnumValue } from '../../../utils/utils'
import { useIntl } from 'react-intl'
import FormSelectAcquisitionResidenceField from '../../../components/fields/FormSelectAcquisitionResidenceField'
import iconsEnum from '../../../enums/iconsEnum'
import Icon from '../../../components/icon/Icon'
import { WHITE } from '../../../theme'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean, nbElements: number }>((theme) => ({
		...styles(theme),
		errorStyle: {
			color: '#B92D00',
			fontSize: 10
		},
		selectStyle: {
			...styles(theme).text1,
			fontSize: 15,
			fontWeight: 500,
			color: theme.palette.blue.main,
			lineHeight: 1.33,

			'& .MuiSelect-root': {
				cursor: props => props.nbElements < 5 ? 'pointer' : 'not-allowed',
			},
			'& .MuiSelect-icon': {
				color: theme.palette.blue.main
			}
		},
		chip: {
			marginTop: 20,
			marginRight: props => props.isLargeScreen ? 15 : 10,
			width: 'fit-content',
			height: props => props.isLargeScreen ? 50 : 45,
			background: WHITE,
			...styles(theme).text20,
			color: theme.palette.blue.main,
			fontSize: props => props.isLargeScreen ? 15 : 12,
			borderRadius: 26,
			textTransform: 'uppercase',
			paddingLeft: props => props.isLargeScreen ? 15 : 8,
			paddingRight: props => props.isLargeScreen ? 15 : 8
		},
		chipCrossIcon: {
			background: theme.palette.blue.main,
			fill: WHITE,
			marginLeft: 10,
			padding: 10,

			'&:hover': {
				fill: theme.palette.blue.main
			}
		}
	}
))

interface AcceptingProps {
	label: React.ReactChild
}

type SelecteurVilleProps =
	FieldArrayRenderProps<villeEnum, HTMLElement>
	& AcceptingProps

const SelecteurVille: React.FC<SelecteurVilleProps> = (
	{
		fields,
		meta,
		label,
		children
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen, nbElements: fields.length ?? 0 })
	const intl = useIntl()

	const getChipLabel = (value: villeEnum) => {
		const enumKey = getKeyFromEnumValue<villeEnum>(villeEnum, value)

		return intl.formatMessage({
			id: `changementAppartement.formulaire.ville.${enumKey}`,
			defaultMessage: 'Paris (75)',
			description: 'Valeur du champ villes et arrondissement souhaités'
		})
	}

	return (
		<Grid container item xs={12}>
			<Grid item xs={12}>
				<span
					className={classNames(
						classes.text5,
						classes.colorBlue,
						{
							[classes.errorStyle]: meta.touched && meta.error
						}
					)}
				>
					{label}
				</span>
			</Grid>

			<Grid container item xs={12}>
				<Grid item xs={12} md={4}>
					<FormSelectAcquisitionResidenceField
						input={{
							value: 0,
							onFocus: () => {
							},
							name: '',
							onChange: (e) => {
								if (!fields.length || fields.length < 5) {
									fields.push(e.target.value)
								}
							},
							onBlur: () => {
							}
						}}
						meta={meta}
						inputTextStyle={classes.selectStyle}
						fullWidth
					>
						{children}
					</FormSelectAcquisitionResidenceField>
				</Grid>

				<Grid container item xs={12}>
					{
						fields.map(
							(field, index) => (
								<Grid key={field} container item className={classes.chip}
								      justify="space-evenly" alignItems="center">
									{getChipLabel(fields.value[index])}

									<IconButton onClick={() => fields.remove(index)}
									            className={classes.chipCrossIcon}>
										<Icon size={15} icon={iconsEnum.Cross} />
									</IconButton>
								</Grid>
							)
						)
					}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default SelecteurVille
